module.exports = __webpack_public_path__ + "static/media/27.376a2c44.svg";